"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";

const ICON_MAP: Record<string, string> = {
  // Microsoft
  microsoft_graph: "/brand-icons/microsoft-graph.webp",
  azure_management: "/brand-icons/azure.svg",
  dynamics_365: "/brand-icons/dynamics-365.svg",
  sharepoint_online: "/brand-icons/sharepoint.png",
  power_bi: "/brand-icons/power-bi.svg",
  microsoft_intune: "/brand-icons/microsoft-intune.png",
  // Google
  google_workspace: "/brand-icons/google-workspace.svg",
  gmail_api: "/brand-icons/gmail.svg",
  google_drive: "/brand-icons/google-drive.svg",
  google_calendar: "/brand-icons/google-calendar.svg",
  google_sheets: "/brand-icons/google-sheets.svg",
  google_cloud: "/brand-icons/google-cloud.svg",
  // AWS
  aws_generic: "/brand-icons/aws.svg",
  aws_s3: "/brand-icons/aws-s3.svg",
  aws_dynamodb: "/brand-icons/aws-dynamodb.svg",
  aws_lambda: "/brand-icons/aws-lambda.svg",
  aws_api_gateway: "/brand-icons/aws-api-gateway.svg",
  aws_secrets_manager: "/brand-icons/aws-secrets-manager.svg",
  // REST APIs
  github: "/brand-icons/github.svg",
  slack: "/brand-icons/slack.svg",
  stripe: "/brand-icons/stripe.svg",
  twilio: "/brand-icons/twilio.svg",
  sendgrid: "/brand-icons/sendgrid.svg",
  hubspot: "/brand-icons/hubspot.svg",
  salesforce: "/brand-icons/salesforce.svg",
  acumatica: "/brand-icons/acumatica.png",
  jsonplaceholder: "/brand-icons/json.svg",
  forgejo_codeberg: "/brand-icons/forgejo.svg",
  discourse_meta: "/brand-icons/discourse.svg",
  pokeapi: "/brand-icons/pokeapi.svg",
  wikipedia_rest: "/brand-icons/wikipedia.svg",
  // Databases
  postgresql: "/brand-icons/postgresql.svg",
  mysql: "/brand-icons/mysql.svg",
  mongodb: "/brand-icons/mongodb.svg",
  redis: "/brand-icons/redis.svg",
  supabase: "/brand-icons/supabase.svg",
  // Documents
  notion: "/brand-icons/notion.svg",
  confluence: "/brand-icons/confluence.svg",
  // Generic
  generic_rest: "/brand-icons/generic-rest.webp",
  generic_graphql: "/brand-icons/generic-graphql.svg",
  generic_database: "/brand-icons/generic-database.svg",
};

interface BrandIconProps {
  templateId: string;
  size?: number;
  className?: string;
}

export function BrandIcon({ templateId, size = 36, className }: BrandIconProps) {
  const src = ICON_MAP[templateId];

  if (!src) {
    return (
      <div
        className={cn(
          "flex items-center justify-center rounded-lg bg-white/[0.06]",
          className,
        )}
        style={{ width: size, height: size }}
      >
        <span className="text-xs text-white/40">?</span>
      </div>
    );
  }

  return (
    <Image
      src={src}
      alt={templateId}
      width={size}
      height={size}
      className={cn("flex-shrink-0", className)}
      unoptimized
    />
  );
}

export { ICON_MAP };
